import { render, staticRenderFns } from "./ModalAccountReceivable.vue?vue&type=template&id=bd155320&"
import script from "./ModalAccountReceivable.vue?vue&type=script&lang=js&"
export * from "./ModalAccountReceivable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports